// css debug mode
const DEBUG_MODE = false;

// link to source code
const PROJECT_LINK = "https://github.com/toxdes/testiny-web";

let API_BASE_URL = "https://api.testiny.txds.me";

export { DEBUG_MODE, API_BASE_URL, PROJECT_LINK };
